import { TbTimeDurationOff } from "react-icons/tb"
import { AiOutlineAppstoreAdd } from "react-icons/ai"
import { GoProjectSymlink } from "react-icons/go"
import { MdExpand } from "react-icons/md"
import { FaBug } from "react-icons/fa"

export const coreTypes = [
  {
    value: 'subscription_expired',
    keyword: 'Subscription Expired',
  },
  {
    value: 'external_application_registration',
    keyword: 'External application registration',
    send: true,
  },
]

export const openStackAdminTypes = [
  {
    value: 'project_request',
    keyword: 'Project Request',
  },
  {
    value: 'limits_update',
    keyword: 'Limits Update',
  },
  {
    value: 'issue_report',
    keyword: 'Issue Report',
  },
]

export const iSenderTypes = [
  {
    value: 'any',
    keyword: 'Any',
  },
]

export const typeIcons = {
  subscription_expired: <TbTimeDurationOff size={36} />,
  external_application_registration: <AiOutlineAppstoreAdd size={36} />,
  project_request: <GoProjectSymlink size={36} />,
  limits_update: <MdExpand size={36} />,
  issue_report: <FaBug size={36} />,
  any: <GoProjectSymlink size={36} />,
}